import { message } from 'antd';
import { authRequest } from './authRequest';
import { STATUS_CODE } from '../constants/statusCode';
import { errorUtils } from '../constants/errorUtils';

export const customRequest = (url, config, successMessage = "Operación realizada con éxito", infoMessage ="Error informativo" ) => {

       return authRequest(url, config)
        .then(() => {
            message.success(successMessage);
            return {statusCode: STATUS_CODE.OK}
            
        }).catch((error) => {
            if (error) {
                if (error.status === STATUS_CODE.BAD_REQUEST) {
                    message.warning(infoMessage)
                    return {statusCode: error.status, message: error.data.errorMessage}

                } else if(error.status > STATUS_CODE.BAD_REQUEST){
                    message.error(errorUtils[error.status])
                }
            }
        }) 
}

